module.exports = __webpack_public_path__ + "img/greater_lightning_elemental_small.9289342e.png";